<section class="uk-section" appResponsiveCheck #resize="appResponsiveCheck">
    <div class="uk-container">
        <div class="uk-child-width-1-3@s" uk-grid>
            <div class="uk-flex uk-flex-center uk-text-center">
                <div *ngIf="resize.responsiveCheck; else callInfoTell">
                    <div class="block-icon uk-border-circle uk-margin-auto uk-box-shadow-medium uk-position-relative" >
                        <img class="uk-position-center" src="assets/images/icon-tel.svg" width="86"/>
                    </div>
                    <p class="uk-text-lead">0 2633 6060</p>
                </div>
                <ng-template #callInfoTell>
                    <a href="tel:026336060">
                        <div class="block-icon uk-border-circle uk-margin-auto uk-box-shadow-medium uk-position-relative" >
                            <img class="uk-position-center" src="assets/images/icon-tel.svg" width="86" />
                        </div>
                        <p class="uk-text-lead">0 2633 6060</p>
                    </a>
                </ng-template>
            </div>
            <div class="uk-flex uk-flex-center uk-text-center">
                <a href="//line.me/ti/p/%40TISCOInsure" target="_blank">
                    <div class="block-icon uk-border-circle uk-margin-auto uk-box-shadow-medium uk-position-relative">
                        <img class="uk-position-center" src="assets/images/icon-line-green.svg" width="86"/>
                    </div>
                    <p class="uk-text-lead">&#64;TISCOInsure</p>
                </a>
            </div>
            <div class="uk-flex uk-flex-center uk-text-center">
                <a routerLink="/faq">
                    <div class="block-icon uk-border-circle uk-margin-auto uk-box-shadow-medium uk-position-relative">
                        <img class="uk-position-center" src="assets/images/icon-question.svg" width="86"/>
                    </div>
                    <p class="uk-text-lead">คำถามที่พบบ่อย</p>
                </a>
            </div>
        </div>
    </div>
</section>
